import api from '../../services/api';

// Task 35 — havuz kural editörü (dinamik havuz filtre kriterleri) ve üye filtreleri
// için paylaşılan async-select yardımcıları (departman/lokasyon arama). Talent-pool
// sayfaları arasında tekrar etmemesi için tek yerde toplanır.

export function buildDepartmentAsync() {
  return {
    onSearch: async (q) => {
      const params = q ? { 'name[like]': q, pageSize: 20 } : { pageSize: 20 };
      const res = await api.get('/v1/departments', { params });
      const r = res.data?.data;
      const items = Array.isArray(r) ? r : (r?.data || []);
      return items.map((d) => ({ id: d.id, name: d.name }));
    },
    onGetById: async (id) => {
      if (!id) return null;
      const res = await api.get(`/v1/departments/${id}`);
      const d = res.data?.data;
      return d ? { id: d.id, name: d.name } : null;
    },
  };
}

// Kademe (iş mimarisi, spec 2026-10-27 §7.5) — etikette seviye de yazar.
export function buildGradeAsync() {
  const label = (g) => `${g.name} (${g.level})`;
  return {
    onSearch: async (q) => {
      const params = q ? { 'name[like]': q, pageSize: 50 } : { pageSize: 50 };
      const res = await api.get('/v1/job-grades', { params });
      const r = res.data?.data;
      const items = Array.isArray(r) ? r : (r?.data || []);
      return items.map((g) => ({ id: g.id, name: label(g) }));
    },
    onGetById: async (id) => {
      if (!id) return null;
      const res = await api.get(`/v1/job-grades/${id}`);
      const g = res.data?.data;
      return g ? { id: g.id, name: label(g) } : null;
    },
  };
}

export function buildLocationAsync() {
  return {
    onSearch: async (q) => {
      const params = q ? { 'name[like]': q, pageSize: 20 } : { pageSize: 20 };
      const res = await api.get('/v1/locations', { params });
      const r = res.data?.data;
      const items = Array.isArray(r) ? r : (r?.data || []);
      return items.map((l) => ({ id: l.id, name: l.name }));
    },
    onGetById: async (id) => {
      if (!id) return null;
      const res = await api.get(`/v1/locations/${id}`);
      const l = res.data?.data;
      return l ? { id: l.id, name: l.name } : null;
    },
  };
}

export function buildEmployeeAsync() {
  return {
    onSearch: async (q) => {
      // EmployeeController yalnız firstName/lastName/fullName [like] bind ediyor —
      // `name[like]` no-op'tu (arama filtrelemiyordu). Bkz. feedback-360/config.
      const params = q ? { 'fullName[like]': q, pageSize: 20 } : { pageSize: 20 };
      const res = await api.get('/v1/employees', { params: { ...params, lookup: true } });
      const r = res.data?.data;
      const items = Array.isArray(r) ? r : (r?.data || []);
      return items.map((e) => ({
        id: e.id,
        name: e.fullName || `${e.firstName || ''} ${e.lastName || ''}`.trim(),
        profilePicture: e.profilePicture,
      }));
    },
    onGetById: async (id) => {
      if (!id) return null;
      const res = await api.get(`/v1/employees/${id}`);
      const e = res.data?.data;
      return e ? { id: e.id, name: e.fullName || `${e.firstName || ''} ${e.lastName || ''}`.trim(), profilePicture: e.profilePicture } : null;
    },
  };
}
